import { Card, Col, Row } from 'antd';
import React from 'react';

interface PropsType {
	enums?: any;
	data?: any;
	changePriceFormat?: any;
}

const BookingCost: React.FC<PropsType> = props => {
	const { data, changePriceFormat } = props;

	const rowStyle: React.CSSProperties = { display: 'flex', justifyContent: 'space-between' };
	const labelStyle: React.CSSProperties = { fontSize: '15px', fontWeight: 'bold' };
	const intervalStyle: React.CSSProperties = { marginTop: '15px' };
	const totalStyle: React.CSSProperties = { width: '100px', display: 'inline-block', textAlign: 'left' };
	const totalRightStyle: React.CSSProperties = { marginRight: '10px', fontSize: '15px', fontWeight: 'bold' };
	const bottomDivStyle: React.CSSProperties = {
		width: '100%',
		height: '50px',
		backgroundColor: '#f8f8f8',
		marginTop: '10px',
		padding: '10px',
		paddingRight: '-10px',
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		fontSize: '15px',
		fontWeight: 'bold',
	};
	return (
		<Card title="预订费用" style={{ marginTop: '20px' }}>
			<div style={rowStyle}>
				<Row gutter={24} style={{ width: '95%' }}>
					<Col span={3} style={labelStyle}>
						车辆租金：
					</Col>
					{data?.rental_bill?.items &&
						data?.rental_bill?.items.map((item: any) => (
							<Col span={4}>{`${item.name}：¥${changePriceFormat(item.amount)}`}</Col>
						))}
				</Row>
				<div style={totalRightStyle}>
					<span>¥{changePriceFormat(data?.rental_bill?.amount) || 0}</span>
				</div>
			</div>
			<div style={{ ...rowStyle, ...intervalStyle }}>
				<Row gutter={24} style={{ width: '95%' }}>
					<Col span={3} style={labelStyle}>
						服务费：
					</Col>
					{data?.service_bill?.items &&
						data?.service_bill?.items.map((item: any) => (
							<Col span={4}>{`${item.name}：¥${changePriceFormat(item.amount)}`}</Col>
						))}
				</Row>
				<div style={totalRightStyle}>
					<span>¥{changePriceFormat(data?.service_bill?.amount) || 0}</span>
				</div>
			</div>
			<div style={{ ...rowStyle, ...intervalStyle }}>
				<Row gutter={24} style={{ width: '95%' }}>
					<Col span={3} style={labelStyle}>
						保障服务：
					</Col>
					{data?.guarantee_bill?.items &&
						data?.guarantee_bill?.items.map((item: any) => (
							<Col span={4}>{`${item.name}：¥${changePriceFormat(item.amount)}`}</Col>
						))}
				</Row>
				<div style={totalRightStyle}>
					<span>¥{changePriceFormat(data?.guarantee_bill?.amount) || 0}</span>
				</div>
			</div>
			<div style={{ ...rowStyle, ...intervalStyle }}>
				<Row gutter={24} style={{ width: '95%' }}>
					<Col span={3} style={labelStyle}>
						优惠金额：
					</Col>
					{data?.promotion_bill?.items &&
						data?.promotion_bill?.items.map((item: any) => (
							<Col span={8}>{`${item.name}：¥${changePriceFormat(item.amount)}`}</Col>
						))}
				</Row>
				<div style={totalRightStyle}>
					<span>-¥{changePriceFormat(data?.promotion_bill?.amount) || 0}</span>
				</div>
			</div>
			<div style={bottomDivStyle}>
				<span style={totalStyle}>订单金额：</span>
				<span style={{ color: '#fc9c4b' }}>¥{changePriceFormat(data.total_amount) || 0}</span>
			</div>
		</Card>
	);
};

export default BookingCost;
